import escapeRegExp from "lodash/escapeRegExp";

import emojiMap from "./generated/emoji.json";
import type { EmojiItem } from "./types";

const CUSTOM_EMOJI_FORMAT_STRING = ":[A-Za-z0-9_-]+:";

const defaultEmojiNames = Object.keys(emojiMap).map((name) => escapeRegExp(name));

export const emojiExactPattern = (customEmojis: ReadonlyArray<EmojiItem>) => {
  return new RegExp(`(${defaultEmojiNames.concat(customEmojis.map((x) => `:${x.name}:`)).join("|")})`);
};

// NOTE: カスタム絵文字が大量に登録されている場合はカスタム絵文字の「候補」を抽出する正規表現を使用する。
//       抽出結果にカスタム絵文字のコードでは「ない」文字列が含まれる可能性があることに注意。
export const emojiCandidatePattern = (customEmojis: ReadonlyArray<EmojiItem>) => {
  if (customEmojis.length < 1000) {
    return emojiExactPattern(customEmojis);
  }

  return new RegExp(`(${[...defaultEmojiNames, CUSTOM_EMOJI_FORMAT_STRING].join("|")})`);
};
